
export const resetPassword = (editor) => {
    const domc = editor.DomComponents;
    var dType = domc.getType("default");
    var dModel = dType.model;
    var dView = dType.view;

    domc.addType("reset-password", {
        model: dModel.extend({
            defaults: Object.assign({}, dModel.prototype.defaults, {
            }),
            init: function () {
                this.set("attributes", {
                    onclick: "resetMemberPassword()",
                });
            },
        },
        {
            isComponent: function (el) {
                if (el.tagName === "a") {
                    return { type: "reset-password" };
                }
            },
        }),
        view: dView,
    });
};